export const initialData = {
  nome: '',
  icon: '',
  path_name: '#'
}
export default initialData;
